import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const UserForm = ({ user, onClose, onSubmit }) => {
  const isEditing = !!user;
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    role: 'staff',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        fullName: user?.fullName || '',
        email: user?.email || '',
        role: user?.role || 'staff',
        password: '',
      });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    try {
      await onSubmit(formData);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-premium border border-border max-w-lg w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <h2 className="text-xl md:text-2xl font-bold text-foreground">
            {isEditing ? 'Modifier l\'utilisateur' : 'Inviter un utilisateur'}
          </h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <Icon name="X" className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4 md:space-y-6">
          <Input
            label="Nom complet"
            value={formData?.fullName}
            onChange={(e) => setFormData(prev => ({ ...prev, fullName: e?.target?.value }))}
            required
            placeholder="Jean Dupont"
          />

          {!isEditing && (
            <Input
              label="Adresse email"
              type="email"
              value={formData?.email}
              onChange={(e) => setFormData(prev => ({ ...prev, email: e?.target?.value }))}
              required
              placeholder="jean@orazek.com"
            />
          )}

          {isEditing && (
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Adresse email</label>
              <p className="px-4 py-2 rounded-lg border border-border bg-muted text-muted-foreground">{user?.email}</p>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Rôle <span className="text-red-400">*</span>
            </label>
            <select
              value={formData?.role}
              onChange={(e) => setFormData(prev => ({ ...prev, role: e?.target?.value }))}
              className="w-full h-10 px-3 py-2 rounded-xl border border-slate-300 dark:border-white/10 bg-white dark:bg-slate-900/60 text-slate-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500/30 appearance-auto"
              required
            >
              <option value="staff">Staff</option>
              <option value="manager">Manager</option>
              <option value="admin">Administrateur</option>
            </select>
          </div>

          {!isEditing && (
            <Input
              label="Mot de passe (optionnel)"
              type="password"
              value={formData?.password}
              onChange={(e) => setFormData(prev => ({ ...prev, password: e?.target?.value }))}
              placeholder="Laisser vide pour auto-générer"
              description="Si vide, un mot de passe aléatoire sera généré. L'utilisateur pourra le réinitialiser."
            />
          )}

          <div className="flex flex-col sm:flex-row justify-end gap-3 pt-4 border-t border-border">
            <Button type="button" variant="outline" onClick={onClose} className="w-full sm:w-auto">
              Annuler
            </Button>
            <Button type="submit" iconName="Save" iconPosition="left" className="w-full sm:w-auto" loading={loading}>
              {isEditing ? 'Modifier' : 'Inviter'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
